export const STRIPE_PRICE_TYPE_FREE_FOREVER = env => (env === 'prod' ? 'price_1HHoQkBVkOjcdYrYjnUcMhDl' : 'price_HOSCuiSGI4BYtB');
export const STRIPE_PRICE_TYPE_GROWTH = env => (env === 'prod' ? 'price_1HHoRPBVkOjcdYrYXZYWDL01' : 'price_HOSQ8m1dDi4ZKX');
